export default "__VITE_ASSET__4F5RtBe8__"